
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import RadioButton from '@/components/radio-button.vue';
	import PageFooter from '@/components/page-footer.vue';
	import {
		memberPerformanceDetailList,
		memberPerformanceOrderFeeList
	} from '@/api/statistic';

	@Component({
		name: 'performance-desc',
		components: {
			RadioButton,
			PageFooter
		}
	})
	export default class PerformanceDesc extends Vue {
		private loading = false;
		private id = this.$route.query.id || '';
		private roleGrade = this.$route.query.roleGrade || '';
		private superId = this.$route.query.superId || '';
		private startTime = this.$route.query.startTime || '';
		private endTime = this.$route.query.endTime || '';
		private list: any = [];
		private filterTime: any = '';
		private orderStrKey = '';
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private radioType = 1;
		private totalOrderFee = 0;
		private radioList: any = [{
			label: '个人业绩',
			value: 1
		}, {
			label: '团队业绩',
			value: 2
		}, {
			label: '服务费(获得)',
			value: 3
		}];

		mounted() {
			this.getList();
		}

		private async getList() {

			this.loading = true;

			let params: any = {
				MemberId: this.id,
				RoleGrade: this.roleGrade,
				SuperId: this.superId,
				Keywords: this.orderStrKey,
				StartTime: this.startTime,
				EndTime: this.endTime,
				IsCompanySend: null,
				Type: this.radioType,
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize
			}
			try {
				let res: any = {};
				if (this.radioType === 3){
					res = await memberPerformanceOrderFeeList(params);
				}else{
					res = await memberPerformanceDetailList(params);
				}
				
				this.list = res.Result.ResultList.Results;
				// console.log(res.Result)
				this.total = res.Result.ResultList.Total;
				this.totalOrderFee = res.Result.StatisticsMoney;
			} catch (err) {
				console.log(err);
			} finally{
				this.loading = false;
			}
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.pageNo = 1;
			this.orderStrKey = '';
			this.getList();
		}

		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private handleBack(){
			this.$router.back();
		}
	}
